<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="buttonClasses"
    @click="$emit('click', $event)"
  >
    <v-icon v-if="icon" :icon="icon" :size="iconSize" />
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';

interface Props {
  variant?: 'primary' | 'secondary' | 'danger' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: string;
  iconSize?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'md',
  type: 'button',
  disabled: false,
  iconSize: 'sm'
});

defineEmits<{
  (e: 'click', event: MouseEvent): void;
}>();

const buttonClasses = computed(() => [
  'cms-btn',
  `cms-btn-${props.variant}`,
  `cms-btn-${props.size}`
]);
</script>

<!-- 
  Styles: Uses global .cms-btn classes from cms-styles.scss
  No component-specific styles needed - all handled via class variants
-->



